<template>
    <div class="page-model-detail" v-if="isShow">
        <div class="detail-cont">
            <div class="top-info article-top-info">
                <div class="art-top-title">{{model.modelName}}</div>
                <div class="type-tags">
                    <span class="tag" v-for="(item, index) in tags" :key="index">{{item.tag}}</span>
                </div>
                <div class="zc-count clearfix">
                    <i class="icon see"></i><span class="much">{{model.viewCount}}</span>
                    <i class="icon pinglun"></i><span class="much">{{model.commentCount}}</span>
                    <i class="icon fenxiang"></i><span class="much">{{model.shareCount}}</span>
                    <!-- <span class="much"><i class="el-icon-more"></i></span> -->
                    <!-- <span class="tips"><i class="el-icon-warning"></i> 未经作者授权，禁止转载</span> -->
                    <span class="date">{{model.createTime | formatTime}}</span>
                </div>
            </div>
            <div class="con-info clearfix">
                <div class="left-info">
                    <v-lunbo v-if="pics.length>0" :pics="pics"></v-lunbo>
                    <div class="model-shuom">
                        <div class="tit">模型说明</div>
                        <div class="words">
                            {{model.modelDescription}}
                        </div>
                    </div>

                    <!-- 评论 -->
                    <div class="pro-work-item clearfix" style="border-top: 5px solid #f6f6f6;">
                        <div class="item-infoes">
                        </div>
                    </div>
                    <!-- 评论 -->

                </div>
                <div class="right-info">
                    <div class="price-num clearfix">
                        <div class="price" v-if="model.modelPrice > 0">￥{{model.modelPrice}}</div>
                        <div class="price" v-else>免费</div>
                        <!-- <div class="num">作品编号：112255</div> -->
                    </div>
                    <ul class="muchs clearfix">
                        <li>下载<span>{{model.downLoadCount}}</span></li>
                        <li>评论<span>{{model.commentCount}}</span></li>
                        <li>收藏<span>{{model.collectCount}}</span></li>
                    </ul>
                    <div class="btns">
                    </div>
                    <div class="atten">
                        <div class="tit-com">注意事项：</div>
                        <div class="words">
                            <p>请仔细阅读描述格式、版本、渲染器和插件。obj、fbx等通用格式不会兼容所有软件，购买前先咨询。</p>
                            <p>格式转换出错、软件不兼容问题不在售后范围内。</p>
                            <p>使用非描述中的格式、版本以及软件环境打开文件可能会有不兼容的问题。此情况不在售后范围内，请按需购买。</p>
                            <p>此模型为三维数字模型，虚拟物品。非实体模型。</p>
                        </div>
                    </div>
                    <div class="geshi">
                        <div class="tit-com">文件格式：</div>
                        <div class="gs-info">
                            <div class="one-item clearfix" v-for="(item, index) in fileFormats" :key="index">
                                <span class="size" v-if="item !='其它'">{{item}}</span>
                            </div>
                            <!--                            <div class="one-item clearfix">-->
                            <!--                                <span class="size">.max:(软件版本2014)</span>-->
                            <!--                                <span class="wra">16.28MB</span>-->
                            <!--                            </div>-->
                            <!--                            <div class="def">渲染器Default</div>-->
                        </div>
                    </div>
                    <ul class="fil-style clearfix">
                        <li class="clearfix" :class="{'active': model.isHasBinding == 1}"><span class="tt">绑定：</span><i
                                class="sty"></i></li>
                        <li class="clearfix" :class="{'active': model.isHasAnimation == 1}"><span
                                class="tt">动画：</span><i class="sty"></i></li>
                        <li class="clearfix" :class="{'active': model.isHasTexture == 1}"><span class="tt">材质：</span><i
                                class="sty"></i></li>
                        <li class="clearfix" :class="{'active': model.isPluginUsed == 1}"><span class="tt">插件：</span><i
                                class="sty"></i></li>
                        <li class="clearfix" :class="{'active': model.isCollapsed == 1}"><span class="tt">未塌陷：</span><i
                                class="sty"></i></li>
                    </ul>
                    <ul class="fil-style clearfix two">
                        <li class="clearfix active" v-show="model.modelPointCount != null && model.modelPointCount != ''">点：<span>{{model.modelPointCount}}</span></li>
                        <li class="clearfix">面：<span>{{model.modelSurfaceCount}}</span></li>
                        <li class="clearfix">布线类型：<span>{{model.layoutType}}</span></li>
                    </ul>
                    <div class="author-info">
                        <div class="info clearifx">
<!--                            <div class="gz-btn" v-show="global.userModel.id != userInfo.userId">-->
<!--                                <el-button v-if="userInfo.followStatus == 2" @click="undoFollower(userInfo.userId)">互相关注-->
<!--                                </el-button>-->
<!--                                <el-button v-if="userInfo.followStatus == 1" @click="undoFollower(userInfo.userId)">已关注-->
<!--                                </el-button>-->
<!--                                <el-button class="wgz-btn" v-if="userInfo.followStatus == 0"-->
<!--                                           @click="follower(userInfo.userId)"><i class="el-icon-plus"></i> 关注-->
<!--                                </el-button>-->
<!--                            </div>-->
                            <div class="lf-info clearfix">
                                <router-link :to="{path:'/home', query: {userId:userInfo.userId}}" class="avatar"
                                             :style="{'background-image': 'url(' + `http://iss.21teacher.com/avatar/125/${userInfo.userId}/20.jpg` + ')'}"></router-link>
                                <div class="name-qm">
                                    <div class="nm oe">
                                        <router-link :to="{path:'/home', query: {userId:userInfo.userId}}">
                                            {{userInfo.userName}}
                                        </router-link>
                                    </div>
                                    <div class="qm oe">{{userInfo.signature}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="works clearfix">
                            <template v-for="(item, index) in modelList">
                                <router-link target="_blank" :key="index"
                                             :to="{path:'/modeldetail', query: {id:item.id,plate:item.belongSection}}"
                                             class="itm"
                                             :style="{'background-image': 'url(' + item.modelCover + ')'}"
                                >
                                </router-link>
                            </template>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import lunbo from './lunbo'
    import axios from 'axios';
    import vue from 'vue';
    import modelApi from '@/api/model'
    import homeApi from '@/api/home'
    import apiService from '@/api/index'
    // import talkPart from '@@/pub/talkpart/talkpart'
    import updateTdk from "@/utils/tdk";
    import {mapState} from "vuex";

    vue.prototype.$axios = axios;
    export default {
        components: {
            'v-lunbo': lunbo,
            // talkPart
        },
        data() {
            return {
                isShow: false,
                headTitle: "title---rrdh",
                headKeywords: "keywords---rrdh",
                headDesc: "description---rrdh",
                isMounted: false, //for control not ssr render
                pics: [],
                model: {},
                tags: [],
                fileList: [],
                fileFormats:[],
                modelList: [],
                userInfo: {},
                callbackurl: "",
                isReload: true,
                objId: 0,
                payStatus: false
            }
        },
        beforeMount() {
            // let id = this.$route.query.id
            // if (id) {
            //   this.objId = parseInt(id)
            // }
            // console.log('--------',id)

        },
        computed: {
            ...mapState(["modelDetail"])
        },
        tdk() {
            return {
                title: this.headTitle,
                description: this.headDesc,
                keywords: this.headKeywords,
                ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
            };
        },
        serverPrefetch() {
            return this.fetchData();
        },
        destroyed() {
            this.$store.commit("SET_MODEL_DETAIL", {detail: null});
        },
        mounted() {
            this.isMounted = true;
            // let id = this.$route.query.id
            this.callbackurl = "login?callback=" + window.location.href;

            const alreadyIncremented = !!this.modelDetail;
            if (!alreadyIncremented) {
                this.fetchData().then(
                    setTimeout(() => {
                        this.initData()
                    }, 1500)
                );
            } else {
                setTimeout(() => {
                    this.initData()
                }, 500)
            }
        },
        methods: {
            setSeo() {
                this.headTitle = this.modelDetail.modelName + "——人人动画网【官网】";
                this.headKeywords = this.modelDetail.modelDescription;
                let desc = this.modelDetail.modelDescription.replace(/<\/?.+?>/g, "").trim()
                this.headDesc = desc.substr(0, 150);
            },
            fetchData() {
                return this.$store
                    .dispatch("FETCH_MODEL_DETAIL", {
                        id: this.$route.query.id
                    })
                    .finally(() => {
                        this.$loading(false);
                        this.setSeo()
                        updateTdk.call(this);
                    });
            },
            initData() {
                let _this = this;
                _this.model = _this.modelDetail
                _this.objId = parseInt(_this.model.id)
                console.log(_this.objId)
                modelApi.select(_this.objId).then(data => {
                    if (data.code == 1) {
                        _this.model = data.response
                        if(_this.model.deleteFlag==1){
                            this.$router.push({
                                path:'/error',
                            })
                        }else{
                            _this.isShow = true
                            _this.userThreeModel(_this.model.creatorId);
                            _this.getUserInfo(_this.model.creatorId)
                            _this.tags = JSON.parse(data.response.modelTags)
                            _this.fileList = data.response.fileList
                            _this.fileFormats = data.response.fileFormats
                            let tempPics = [];
                            data.response.picList.forEach(item => {
                                let temp = {id: item.id, path: item.uri}
                                tempPics.push(temp)
                            })
                            data.response.picList2.forEach(item => {
                                let temp = {id: item.id, path: item.uri}
                                tempPics.push(temp)
                            })
                            _this.pics = tempPics
                        }

                    } else {
                        _this.$message.error(data.message)
                    }
                })
            },
            userThreeModel(userId) {
                let _this = this
                modelApi.userThreeModel(userId,1).then(data => {
                    if (data.code == 1) {
                        _this.modelList = data.response
                    }
                })
            },
            getUserInfo(userId) {
                let _this = this;
                let url = '/rrbi/userInfo/userInfo/' + userId + '?time=' + new Date().getMilliseconds();
                _this.$axios.get(url).then(function (result) {
                    if (result.data.code == 1) {
                        _this.userInfo = result.data.response
                    }
                })
            },

            reloadModel() {
                let _this = this
                // 移除组件
                _this.isReload = false
                // 在组件移除后，重新渲染组件
                // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
                _this.$nextTick(() => {
                    _this.isReload = true
                })
            },
            toLog() {
                this.$router.push({
                    path: '/login?callback=' + window.location.href,
                })

            },
        }

    }
</script>

<style scoped lang="less">
    //@import "../../../assets/less/stylePublic.less";

    .page-model-detail {
        padding-top: @NAVHEIGHT;

        .detail-cont {
            margin: 30px auto;
            min-height: 500px;
            background: #fff;

            .con-info {
                margin-top: 20px;

                .left-info {
                    float: left;

                    .model-shuom {
                        margin: 30px 0 10px;
                        background: #f6f6f6;

                        .tit {
                            padding: 12px 25px;
                            color: #000;
                            font-size: 16px;
                            line-height: 24px;
                            border-bottom: 1px solid #fff;
                        }

                        .words {
                            padding: 20px 25px;
                            color: #808080;
                            font-size: 14px;
                            line-height: 24px;
                        }
                    }
                }

                .right-info {
                    float: right;

                    .price-num {
                        height: 45px;
                        line-height: 45px;
                        border-bottom: 2px solid #f6f6f6;

                        .price {
                            float: left;
                            color: #ed4b58;
                            font-size: 22px;
                        }

                        .num {
                            float: right;
                            font-size: 14px;
                        }
                    }

                    .muchs {
                        border-bottom: 1px solid #f6f6f6;

                        li {
                            position: relative;
                            padding: 10px 0;
                            float: left;
                            width: 33.333%;
                            line-height: 24px;
                            font-size: 15px;
                            color: #808080;
                            text-align: center;

                            &:after {
                                position: absolute;
                                right: 0;
                                top: 12px;
                                content: '';
                                display: block;
                                width: 1px;
                                height: 20px;
                                background: #f6f6f6;
                            }

                            &:nth-child(3):after {
                                display: none;
                            }

                            span {
                                margin-left: 4px;
                                color: #ed4b58;
                            }
                        }
                    }

                    .btns {
                        padding: 10px 0;

                        .btn {
                            display: inline-block;
                            margin-left: 0;
                            padding-left: 0;
                            padding-right: 0;
                            width: 30%;

                            .el-button {
                                width: 100%;

                                &.el-button--danger {
                                    padding-left: 0;
                                    padding-right: 0;
                                    background-color: @HEADBG;
                                    border-color: @HEADBG;
                                }
                            }

                            &.el-button--warning {
                                background-color: #fbcd20;
                                border-color: #fbcd20;
                            }
                        }

                        .mar-btn {
                            margin-right: 5%;
                        }

                        .ls.mar-btn {
                            margin-right: 0;
                        }
                    }

                    .tit-com {
                        padding: 12px 25px;
                        color: #000;
                        font-size: 16px;
                        line-height: 24px;
                        border-bottom: 1px solid #fff;
                    }

                    .atten {
                        background: #f6f6f6;

                        .words {
                            padding: 10px 10px 10px 30px;

                            p {
                                position: relative;
                                font-size: 14px;
                                line-height: 26px;

                                &:before {
                                    position: absolute;
                                    left: -15px;
                                    top: 10px;
                                    content: '';
                                    display: block;
                                    width: 6px;
                                    height: 6px;
                                    background: #b3b3b3;
                                    border-radius: 50%;
                                }
                            }
                        }
                    }

                    .geshi {
                        margin: 10px 0;
                        background: #f6f6f6;

                        .gs-info {
                            padding: 5px 20px 10px;

                            .one-item {
                                margin: 5px 0;
                                font-size: 14px;

                                .size {
                                    float: left;
                                }

                                .wra {
                                    float: right;
                                }
                            }

                            .def {
                                font-size: 14px;
                            }
                        }
                    }

                    .fil-style {
                        margin-bottom: 10px;
                        padding: 15px 25px;
                        background: #f6f6f6;
                        color: #808080;

                        li {
                            float: left;
                            margin: 10px 0;
                            width: 33%;
                            font-size: 14px;

                            .tt {
                                float: left;
                                font-size: 12px;
                            }

                            i {
                                float: left;
                                width: 18px;
                                height: 18px;
                                background-image: url('../../../assets/images/fil_style_02.jpg');
                                background-size: 100%;
                            }

                            &.active {
                                i {
                                    background-image: url('../../../assets/images/fil_style_01.jpg');
                                }
                            }
                        }

                        &.two {
                            li {
                                width: 50%;

                                span {
                                    color: #000;
                                }

                                &:last-child {
                                    width: 100%;
                                }
                            }
                        }
                    }

                    .author-info {
                        margin-bottom: 10px;
                        padding: 15px 25px;
                        background: #f6f6f6;
                        color: #808080;

                        .info {
                            .lf-info {
                                margin-right: 65px;

                                .avatar {
                                    float: left;
                                    display: block;
                                    width: 55px;
                                    height: 55px;
                                    background-size: cover;
                                    border-radius: 50%;
                                }

                                .name-qm {
                                    padding: 5px 0;
                                    margin-left: 60px;

                                    .oe {
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        white-space: nowrap;
                                    }

                                    .nm {
                                        line-height: 25px;

                                        a {
                                            color: #000;
                                            font-size: 16px;
                                            font-weight: bold;
                                        }
                                    }

                                    .qm {
                                        display: block;
                                        line-height: 20px;
                                        color: #999;
                                        font-size: 14px;
                                    }
                                }
                            }

                            .gz-btn {
                                float: right;
                                margin-top: 12px;
                            }
                        }

                        .works {
                            margin-top: 10px;

                            .itm {
                                float: left;
                                margin-right: 2.3%;
                                padding-bottom: 21.32%;
                                width: 31.8%;
                                height: 0;
                                background-size: cover;

                                &:last-child {
                                    margin-right: 0;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: 750px) {
        .page-model-detail {
            .detail-cont {
                margin-top: 10px;
                margin-bottom: 0;
                width: 100%;

                .top-info {
                    padding: 10px;
                }

                .con-info {
                    .left-info {
                        float: none;
                        padding: 0 10px;

                        /deep/ .lunbo-wrap {
                            .img-list {
                                display: none;
                            }
                        }

                        .model-shuom {
                            margin-top: 10px;

                            .tit {
                                padding: 10px;
                            }

                            .words {
                                padding: 10px 0 10px 10px;
                            }
                        }
                    }

                    .right-info {
                        float: none;
                        padding: 10px 10px 0;
                        width: 100%;
                        border-top: 2px solid #f6f6f6;

                        .tit-com {
                            padding: 10px;
                        }
                    }
                }
            }
        }
    }

    @media screen and (min-width: 751px) {
        .page-model-detail {
            .detail-cont {
                width: 700px;

                .top-info {
                    padding: 20px;
                }

                .con-info {
                    .left-info {
                        float: none;
                        padding: 0 20px;
                        width: 100%;
                    }

                    .right-info {
                        float: none;
                        padding: 10px 20px 0;
                        width: 100%;
                        border-top: 2px solid #f6f6f6;
                    }
                }
            }
        }
    }

    @media screen and (min-width: 1024px) {
        .page-model-detail {
            .detail-cont {
                width: 1000px;

                .top-info {
                    padding: 20px;
                }

                .con-info {
                    .left-info {
                        float: left;
                        margin-left: 10px;
                        padding: 0;
                        width: 700px;
                    }

                    .right-info {
                        float: right;
                        margin-right: 10px;
                        padding: 0;
                        width: 270px;
                        border-top: none;
                    }
                }
            }
        }
    }

    @media screen and (min-width: 1366px) {
        .page-model-detail {
            .detail-cont {
                width: 1200px;

                .top-info {
                    padding: 30px 0 10px 30px;
                    width: 760px;
                }

                .con-info {
                    .left-info {
                        margin-left: 30px;
                        width: 730px;
                    }

                    .right-info {
                        margin-right: 30px;
                        width: 380px;
                    }
                }
            }
        }
    }
</style>
